export default {
    methods: {
        scopeTitle(scope, scopes) {
            return _.get(_.find(scopes, {
                scope: scope
            }), 'title', scope);
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/survey/scopeTitle.js